import { useCountUp } from "../../hooks/useCountUp";

export default function CountUpText({ value, duration = 1000, className = "" }) {
  const animatedValue = useCountUp(value, duration);

  return (
    <span className={`transition-opacity duration-300 ${className}`}>
      {animatedValue}
    </span>
  );
}